const YearDataLife = [
    // { "label": "18 Years", "value": "18" },
    // { "label": "19 Years", "value": "19" },
    // { "label": "20 Years", "value": "20" },
    // { "label": "21 Years", "value": "21" },
    // { "label": "22 Years", "value": "22" },
    // { "label": "23 Years", "value": "23" },
    { "label": "24 Years", "value": "24" },
    { "label": "25 Years", "value": "25" },
    { "label": "26 Years", "value": "26" },
    { "label": "27 Years", "value": "27" },
    { "label": "28 Years", "value": "28" },
    { "label": "29 Years", "value": "29" },
    { "label": "30 Years", "value": "30" },
    { "label": "31 Years", "value": "31" },
    { "label": "32 Years", "value": "32" },
    { "label": "33 Years", "value": "33" },
    { "label": "34 Years", "value": "34" },
    { "label": "35 Years", "value": "35" },
    { "label": "36 Years", "value": "36" },
    { "label": "37 Years", "value": "37" },
    { "label": "38 Years", "value": "38" },
    { "label": "39 Years", "value": "39" },
    { "label": "40 Years", "value": "40" },
    { "label": "41 Years", "value": "41" },
    { "label": "42 Years", "value": "42" },
    { "label": "43 Years", "value": "43" },
    { "label": "44 Years", "value": "44" },
    { "label": "45 Years", "value": "45" },
    { "label": "46 Years", "value": "46" },
    { "label": "47 Years", "value": "47" },
    { "label": "48 Years", "value": "48" },
    { "label": "49 Years", "value": "49" },
    { "label": "50 Years", "value": "50" },
    { "label": "51 Years", "value": "51" },
    { "label": "52 Years", "value": "52" },
    { "label": "53 Years", "value": "53" },
    { "label": "54 Years", "value": "54" },
    { "label": "55 Years", "value": "55" },
    { "label": "56 Years", "value": "56" },
    { "label": "57 Years", "value": "57" },
    { "label": "58 Years", "value": "58" },
    { "label": "59 Years", "value": "59" },
    { "label": "60 Years", "value": "60" },
    { "label": "61 Years", "value": "61" },
    { "label": "62 Years", "value": "62" },
    { "label": "63 Years", "value": "63" },
    { "label": "64 Years", "value": "64" },
    { "label": "65 Years", "value": "65" },
    { "label": "66 Years", "value": "66" },
    { "label": "67 Years", "value": "67" },
    { "label": "68 Years", "value": "68" },
    { "label": "69 Years", "value": "69" },
    { "label": "70 Years", "value": "70" },
    { "label": "71 Years", "value": "71" },
    { "label": "72 Years", "value": "72" },
    { "label": "73 Years", "value": "73" },
    { "label": "74 Years", "value": "74" },
    { "label": "75 Years", "value": "75" },
    { "label": "76 Years", "value": "76" },
    { "label": "77 Years", "value": "77" },
    { "label": "78 Years", "value": "78" },
    { "label": "79 Years", "value": "79" },
    { "label": "80 Years", "value": "80" },
    { "label": "81 Years", "value": "81" },
    { "label": "82 Years", "value": "82" },
    { "label": "83 Years", "value": "83" },
    { "label": "84 Years", "value": "84" },
    { "label": "85 Years", "value": "85" },
    { "label": "86 Years", "value": "86" },
    { "label": "87 Years", "value": "87" },
    { "label": "88 Years", "value": "88" },
    { "label": "89 Years", "value": "89" },
    { "label": "90 Years", "value": "90" },
    { "label": "91 Years", "value": "91" },
    { "label": "92 Years", "value": "92" },
    { "label": "93 Years", "value": "93" },
    { "label": "94 Years", "value": "94" },
    { "label": "95 Years", "value": "95" },
    { "label": "96 Years", "value": "96" },
    { "label": "97 Years", "value": "97" },
    { "label": "98 Years", "value": "98" },
    { "label": "99 Years", "value": "99" },
    { "label": "100 Years", "value": "100" }
  ]
  

  export default YearDataLife